import {IParams, RecursosController} from "../recursos";

declare global {
    interface Window {
        SsmBesoccerVideo: any;
    }
}

export class BesoccerController extends RecursosController {

    /* INSTANCE */
    public static instance: BesoccerController;

    /* STATIC */
    public static override async build(): Promise<void> {
        BesoccerController.instance = new this();
        RecursosController.instances.push(BesoccerController.instance);
    }

    constructor() {
        super();
        this.getResources(document.body).then(async()=>{
            await this.init();
            this.scrollEvent = this.lazyResources.bind(this);
            document.addEventListener("scroll", this.scrollEvent);
        });
    }

    protected async getResources(html: HTMLElement): Promise<void> {
        const resources = Array.from(html.querySelectorAll("[class*='besoccer-video'], [class*='besoccer-widget']"));
        for (let resource of resources) this.resources.push(resource as HTMLElement);
    }

    protected async load(item: HTMLElement): Promise<void> {
        item.innerHTML = item.getAttribute("data-lazy") as string;
        if (item.className.includes("video")) {
            const urls: IParams[] = [{name: "script-video-besoccer", value: "https://scripts.ssm.codes/besoccer-video.js"}, {name: "script-monetizacion-besoccer", value: "https://ssm.codes/smart-tag/estadiodeportivocom.js"}];
            const promesas = await this.initPromises(urls);
            await Promise.all(promesas).then(async () => {
                await this.loadBeSoccer(item);
            });
        }
    }

    private async loadBeSoccer(item: HTMLElement): Promise<void> {
        new window.SsmBesoccerVideo(item.firstElementChild).create();
    }

}
